var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { createDataClass } from "../../../lib/utils/types";
import { LazyGetter } from '@tencent/data-schema-core';
const DepBase = createDataClass();
export class Dep extends DepBase {
  /**
   * 获取当前 place 所对应的 compPath。注意，因为空字符串也是有效的 compPath，所以，如果没有对应的组件，这个会返回 `null`
   */
  get compPath() {
    const {
      place
    } = this;
    if (place[0] !== 'layout') return null; // 只收集 layout 上面的
    let compPath = '';
    for (let i = 1; i < place.length; i++) {
      const m1 = place[i];
      let slotId;
      let slotIndex;
      if (m1 === 'children') {
        slotId = 'default';
        slotIndex = place[i + 1];
        i += 1; // 跳过后面的 index
      }
      if (m1 === 'slots') {
        slotId = place[i + 1];
        slotIndex = place[i + 2];
        i += 2; // 跳过后面的 index
      }
      if (typeof slotId === 'string' && typeof slotIndex === 'number') compPath += `/${slotId}/${slotIndex}`;else break; // 无法构造 CompPath 了
    }
    return compPath;
  }
}
__decorate([LazyGetter()], Dep.prototype, "compPath", null);
//# sourceMappingURL=Dep.js.map
